<template>
  <div :class="['admin-cell-dialog-text', { empty: isEmpty }]">
    <v-edit-dialog
      ref="dialog"
      :return-value.sync="theValue"
      v-on="$listeners"
      @save="save"
      @cancel="cancel"
      @open="open"
      large
    >
      <div class="activator-container" :style="containerStyles">
        <AdminCellEmptyPlaceholder v-if="isEmpty" />
        <div class="activator-text truncate" v-else>{{ value }}</div>
      </div>
      <template v-slot:input>
        <slot name="default">
          <v-textarea
            v-model="theValue"
            label="Edit"
            autofocus
            rows="4"
            hide-details
            @keydown.meta.enter="saveHandler"
          />
        </slot>
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminCellEmptyPlaceholder from '@/components/AdminCellEmptyPlaceholder'

export default {
  name: 'AdminCellDialogText',
  components: { AdminCellEmptyPlaceholder },
  inject: {
    cancel: { default: null },
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      theValue: this.value,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      if (!maxWidth) {
        maxWidth = '70vw !important'
      }
      return {
        maxWidth,
      }
    }, // containerStyles
    isEmpty() {
      return this.value === '' || this.value == null
    }, // isEmpty
  },
  methods: {
    save() {
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == this.theValue) return
        const fields = { [this.fieldName]: this.theValue }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
    saveHandler() {
      this.save()
      this.$refs.dialog.save()
    }, // saveHandler
    async open() {
      this.theValue = this.value
    }, // open
  },
}
</script>

<style lang="scss">
.activator-container {
  position: relative;
}
.truncate {
  height: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.admin-cell-dialog-text .v-small-dialog__activator__content {
  min-width: 100%;
  width: 100%;
}
</style>
